import { DateRange } from '@mui/x-date-pickers-pro';
import { DATE_AND_TIME_FORMAT, DATE_FORMAT } from 'shared';
import { DateTime } from 'luxon';

export const validateDateRequired = (val: DateRange<DateTime>) => {
  return val.every((e) => e?.isValid) ? true : 'Fülle bitte das Feld aus';
};

export const getFormattedDateTime = (date?: string) =>
  date ? DateTime.fromJSDate(new Date(date)).toFormat(DATE_AND_TIME_FORMAT) : null;

export const getFormattedDate = (date?: string) =>
  date ? DateTime.fromJSDate(new Date(date)).toFormat(DATE_FORMAT) : null;

export const formatDate = (date: DateTime, format: string = 'dd.MM.yy') => {
  return date.toFormat(format);
};

// Simple helper to get the correct German day word based on context
// Use 'dative' context when using prepositions like: vor, in, seit, nach, an, zu
// Examples: "vor 3 Tagen", "in 5 Tagen", "seit 2 Tagen"
// Use 'nominative' context for direct counting or with accusative prepositions
// Examples: "noch 3 Tage", "läuft 5 Tage", "für 2 Tage"
export const getDayWord = (days: number | undefined, context: 'nominative' | 'dative' = 'nominative'): string => {
  if (days === undefined || days === 0) return '';
  if (days === 1) return 'Tag';
  return context === 'nominative' ? 'Tage' : 'Tagen';
};

export const getCeilDays = (days: number | undefined): number => {
  return Math.ceil(days ?? 0);
};
